var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageName)?_c('img',{staticClass:"image is-96x96",attrs:{"src":_vm.imageUrl,"alt":"img"},on:{"click":_vm.setPreviewUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }